'use strict';
var KeyMirror = require('keymirror');

module.exports = {

    ActionTypes: KeyMirror({
        UPDATE_PENSION_PAYMENT_MODEL: null,
        UPDATE_PENSION_PAYMENT_INVESTMENT_OPTION: null,
        SET_PENSION_ALLOCATION_SAME_AS_INV_ALLOCATION: null
    }),
    AccountStart: {
        ASAP: 'ASAP',
        CUSTOM: 'CUSTOM'
    },
    AccountStartData: [
        { id: 'ASAP', name: 'As soon as possible', isHidden: false },
        { id: 'CUSTOM', name: 'Select date', isHidden: false }
    ],
    PaymentLevels: {
        MINIMUM: 'minimum',
        MAXIMUM: 'maximum',
        SPECIFIC: 'specific'
    },
    PaymentLevelsData: [
        { id: 'minimum', name: 'Minimum level', isHidden: false, showNotPreRetirement: true },
        { id: 'maximum', name: 'Maximum level', isHidden: false, showNotPreRetirement: false },
        { id: 'specific', name: 'Specific amount', isHidden: false, showNotPreRetirement: true }
    ],
    AnnualIncrease: {
        INCREASE: 'increase',
        SET: 'set',
        NO_THANKS: 'nothanks'
    },
    AnnualIncreaseData: [
        { id: 'increase', name: 'Increase with inflation', isHidden: false },
        { id: 'set', name: 'Set a percentage', isHidden: false },
        { id: 'nothanks', name: 'No thanks', isHidden: false }
    ],
    DrawDownOption: {
        CONSERVATIVE: 'conservative',
        CUSTOM: 'custom'
    },
    DrawDownOptionData: [
        { id: 'conservative', name: 'In order of more conservative', isHidden: false },
        { id: 'custom', name: 'Custom ordering', isHidden: false }
    ],
    DrawDownTypeOption: {
        ORDER: 'order',
        PERCENTAGE: 'percentage'
    },
    DrawDownTypeOptionData: [
        { id: 'order', name: 'By order', isHidden: false },
        { id: 'percentage', name: 'By percentage', isHidden: false }
    ],
    InvestmentOptionErrorTypes: {
        MUST_BE_NUMBERS: 'investmentAllocationMustBeNumbers',
        MUST_NOT_EXCEED: 'investmentAllocationMustNotExceed',
        MUST_TOTAL_100: 'investmentAllocationMustTotal100',
        MUST_NUMBER_ALL: 'investmentAllocationMustNumberAll',
        MUST_NOT_GO_BEYOND: 'investmentAllocationMustNotGoBeyond',
        MUST_NOT_BE_A_DUPLICATE: 'investmentAllocationMustNotBeADuplicate',
        MUST_BE_NUMBERS_ONLY: 'investmentAllocationMustBeNumbersOnly'
    },
    PensionPaymentData: {
        accountStartDateOption: 'ASAP',
        accountStartDate: '',
        selectedBankAccount: '',
        accountHolderName: '',
        branchNumber: '',
        accountNumber: '',
        paymentFrequency: 'monthly',
        yearlyFrequencyDate: '',
        deferPayments: 'N',
        deferPaymentsText: '',
        deferPaymentsWithinFYearText: '',
        paymentLevelsOption: 'minimum',
        paymentGrossAmount: '',
        annualIncreaseOption: 'nothanks',
        annualPercentage: '',
        drawDownOption: 'conservative',
        drawDownTypeOption: '',
        investmentOptionList: [],
        totalAllocationPercentage: '0.00',
        proRataFirstPayment: 'Y',
        firstPaymentDuringCoolingOff: 'N'
    },
    nominateOtherAccount: 'nominate',
    pensPayment: 'pensPayment',
    june: 6,
    pensPaymentInvOptPrefix: 'pensPayment-',
    PaymentFrequency: {
        FORTNIGHTLY: 'fortnightly',
        MONTHLY: 'monthly',
        QUARTERLY: 'quarterly',
        HALFYEARLY: 'halfYearly',
        YEARLY: 'yearly'
    },
    PaymentFrequencyData: [
        { id: 'fortnightly', name: 'Fortnightly', code: '26 payments per year paid on alternating Wednesdays', disabled: false },
        { id: 'monthly', name: 'Monthly', code: '12 payments per year paid on or around the 25th of each month', disabled: false },
        { id: 'quarterly', name: 'Quarterly', code: '4 payments per year paid on or around 25th of March, June, Sept and Dec', disabled: false },
        { id: 'halfYearly', name: 'Half-yearly', code: '2 payments per year paid on or around the 25th of June and December', disabled: false },
        { id: 'yearly', name: 'Yearly', code: '1 payment per year paid on or around the 25th of your chosen month', disabled: false }
    ],
    PaymentFrequencyDates: [
        { id: '01', name: 'January' },
        { id: '02', name: 'February' },
        { id: '03', name: 'March' },
        { id: '04', name: 'April' },
        { id: '05', name: 'May' },
        { id: '06', name: 'June' },
        { id: '07', name: 'July' },
        { id: '08', name: 'August' },
        { id: '09', name: 'September' },
        { id: '10', name: 'October' },
        { id: '11', name: 'November' },
        { id: '12', name: 'December' }
    ],
    Labels: {
        ACC_START_OPT_LABEL: 'Pension account commencement date',
        PAYMENT_CREDITED_ACCT_LABEL: 'Credited to the following account',
        NAME_ACC_HOLDER_LABEL: 'Name of account holder',
        BRANCH_NUMBER_LABEL: 'Branch number (BSB)',
        ACC_NUMBER_LABEL: 'Account number',
        PAYMENT_FREQUENCY_LABEL: 'Pension payment frequency',
        PAYMENT_FREQUENCY_YEARLY_LABEL: '1 payment per year paid on or around the 25th of {{code}}',
        YEARLY_FREQUENCY_TEXT_LABEL: 'Yearly frequency text',
        DEFER_PAYMENTS_LABEL: 'Defer pension payment until next financial year',
        PAYMENT_GROSS_AMOUNT_LABEL: 'Gross amount per pension payment',
        ANNUAL_PERCENTAGE_LABEL: 'Annual increase',
        DRAW_DOWN_OPTION_LABEL: 'Draw down of payments from your investment options',
        FIRST_PAYMENT_COOLING_OFF_LABEL: 'Receive first pension payment during the 14 day cooling-off period',
        PRO_RATA_FIRST_PAYMENT_LABEL: 'First payment to be pro rata'
    },
    FieldNames: {
        ACC_START_OPT: 'accountStartDateOption',
        ACC_START_DATE: 'accountStartDate',
        SELECTED_BANK_ACC: 'selectedBankAccount',
        NAME_ACC_HOLDER: 'accountHolderName',
        BRANCH_NUMBER: 'branchNumber',
        ACC_NUMBER: 'accountNumber',
        PAYMENT_FREQUENCY: 'paymentFrequency',
        YEARLY_FREQUENCY_DATE: 'yearlyFrequencyDate',
        DEFER_PAYMENTS: 'deferPayments',
        DEFER_PAYMENTS_WITHIN_FYEAR_TEXT: 'deferPaymentsWithinFYearText',
        DEFER_PAYMENTS_TEXT: 'deferPaymentsText',
        PAYMENT_LEVEL_OPTIONS: 'paymentLevelsOption',
        PAYMENT_GROSS_AMOUNT: 'paymentGrossAmount',
        ANNUAL_INCREASE_OPTIONS: 'annualIncreaseOption',
        ANNUAL_PERCENTAGE: 'annualPercentage',
        DRAW_DOWN_OPTION: 'drawDownOption',
        DRAW_DOWN_TYPE_OPTION: 'drawDownTypeOption',
        INVESTMENT_OPTION_LIST: 'investmentOptionList',
        TOTAL_ALLOCATION_PERCENTAGE: 'totalAllocationPercentage'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/PensionPaymentConstants.js